module.exports = __webpack_public_path__ + "static/office_preview-7fafdf480640237d8761cccaf7996532.png";